<template>
  <div class="card bg-white rounded-lg p-6 border border-gray-400">
    <div class="card-body p-0">
      <div class="overflow-hidden rounded-lg">
        <table class="table table-striped w-full">
          <thead>
            <tr>
              <th colspan="5" class="p-4">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="form-inline">
                    <label>Show&nbsp;</label>
                    <b-form-select
                      v-model="queries.per_page"
                      class="ml-1 mr-1"
                      size="sm"
                      :options="[10, 15, 25, 50, 100]"
                      @change="getSubscriptions"
                    ></b-form-select>
                    <span>entries</span>
                  </div>
                  <div class="form-inline">
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="queries.search"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                        @keyup.enter="getSubscriptions"
                      ></b-form-input>
                    </label>
                    <button class="ml-1 btn btn-dark-blue btn-sm" :disabled="searching" @click="getSubscriptions">
                      <span v-if="searching">
                        <b-spinner small class="mr-1" />
                      </span>
                      <i v-else class="uil uil-search-alt"></i>
                    </button>
                  </div>
                </div>
              </th>
            </tr>

          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="6" class="text-center">
                <b-spinner label="Loading..." variant="primary" small></b-spinner>
              </td>
            </tr>
            <tr v-else>
              <th class="pl-4 px-6 py-2 text-left font-semibold" scope="row">Name</th>
              <th class="px-6 py-2 text-left font-semibold">Amount</th>
              <th class="px-6 py-2 text-left font-semibold">Interval</th>
              <th class="px-6 py-2 text-left font-semibold">Type</th>
              <th class="px-6 py-2 text-left font-semibold" width="160">Actions</th>
            </tr>
            <tr v-for="sub in subscriptions" :key="sub.id" class="align-middle">
              <td class="pl-4 px-6 py-2 border-bottom" scope="row">{{ sub.name }}</td>
              <td class="px-6 py-2 border-bottom">${{ sub.amount }}</td>
              <td class="px-6 py-2 border-bottom">{{ sub.interval }}</td>
              <td class="px-6 py-2 border-bottom">{{ sub.mode }}</td>
              <td class="px-6 py-2 border-bottom">
                <b-button size="sm" variant="danger" class="ml-2" @click="confirmCancel(sub)">Cancel Subscription</b-button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5" class="pt-4 px-4 pb-0">
                <div class="row">
                  <div class="col">
                    <div class="float-left">
                      Total {{ totalSubscriptions }} subscriptions
                    </div>
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination
                          v-model="queries.page"
                          :total-rows="totalSubscriptions"
                          :per-page="queries.per_page"
                          @change="onPageChanged"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <b-modal v-model="showCancelConfirm" title="Cancel Subscription" :ok-disabled="canceling" @ok="cancelSubscription">
        <template v-if="canceling">
          <b-spinner small type="grow" class="mr-2" />
          Cancelling subscription...
        </template>
        <template v-else>
          Are you sure you want to cancel this subscription?
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscriptions: [],
      queries: {
        page: 1,
        per_page: 10,
        search: '',
      },
      totalSubscriptions: 0,
      showCancelConfirm: false,
      cancelingSubscription: null,
      canceling: false,
      searching: false,
      loading: false,
    };
  },
  created() {
    this.getSubscriptions();
  },
  methods: {
    getSubscriptions() {
      this.searching = true;
      this.loading = true;
      this.$store.dispatch('agencySubscription/fetchSubscriptions', this.queries).then(res => {
        // Defensive: handle undefined or unexpected API response
        if (res && Array.isArray(res.data)) {
          this.subscriptions = res.data.map(sub => ({
            name: sub.user?.full_name || '',
            amount: sub.agency_subscription?.amount || '',
            mode: sub.agency_subscription?.mode || '',
            interval: sub.agency_subscription?.interval || '',
            id: sub.id,
            raw: sub
          }));
        } else {
          this.subscriptions = [];
        }
        this.totalSubscriptions = res && typeof res.total === 'number' ? res.total : 0;
      }).finally(() => {
        this.searching = false;
        this.loading = false;
      });
    },
    confirmCancel(sub) {
      this.cancelingSubscription = sub.id;
      this.showCancelConfirm = true;
      this.canceling = false;
    },
    cancelSubscription() {
      if (!this.cancelingSubscription) return;
      this.canceling = true;
      this.$store.dispatch('agencySubscription/cancelSubscription', this.cancelingSubscription)
        .then(() => {
          this.getSubscriptions();
          this.showCancelConfirm = false;
          this.cancelingSubscription = null;
        })
        .finally(() => {
          this.canceling = false;
        });
    },
    onPageChanged(page) {
      this.queries.page = page;
      this.getSubscriptions();
    }
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #dee2e6;
}
.header-gray thead {
  background-color: #f3f4f6; /* Tailwind bg-gray-100 */
}
.header-gray th {
  background-color: #f3f4f6 !important;
  color: #374151;
  font-weight: 600;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
